var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b51bc95913295820b820b94a17ac35362724c682"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["byma-producer-web@byma"]={id:"b51bc95913295820b820b94a17ac35362724c682"};
      